/** @format */

import React from "react";

// type galleryItemProps = {
//   image: string | undefined;
//   title: string;
// };

const GalleryItem = (props: any) => {
  const { data, dataIndex } = props;
  const { image, title } = data[dataIndex];
  return (
    <div
      style={{
        width: "100%",
        height: 400,
        userSelect: "none",
        margin: "auto",
      }}
      className="m-auto"
    >
      <img
        style={{
          height: "100%",
          width: "180%",
          objectFit: "cover",
          borderRadius: 0,
          // backgroundPosition: "center",
        }}
        draggable={false}
        src={image}
        alt={title}
      />
    </div>
  );
};

export default GalleryItem;
